import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "streamListContainerRef", class: {
    "horizontal-infinity-layout": _setup.isHorizontalInfinityLayout,
    "vertical-infinity-layout": _setup.isVerticalInfinityLayout,
    "equal-points-layout": _setup.isEqualPointsLayout
  } }, [_c("div", { ref: "streamListRef", staticClass: "stream-list", style: _setup.streamListStyle, on: { "wheel": _setup.handleWheel } }, _vm._l(_setup.validStreamInfoList, function(streamInfo) {
    return _c(_setup.StreamRegion, { key: `${streamInfo.userId}_${streamInfo.streamType}`, staticClass: "stream-list-item", style: _setup.streamStyle, attrs: { "streamInfo": streamInfo, "streamPlayMode": _vm.streamPlayMode, "streamPlayQuality": _vm.streamPlayQuality }, on: { "stream-view-dblclick": _setup.handleStreamDblClick } });
  }), 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "923eab12"
);
const StreamList = __component__.exports;
export {
  StreamList as default
};
